<template>
  <div
    class="markBox"
    :id="chart_id"
    :style="{ width: width + 'px', height: height + 'px' }"
  ></div>
</template>

<script>
let echarts = require("echarts/lib/echarts");
require("echarts/lib/chart/bar");
require("echarts/lib/component/legend");
require("echarts/lib/component/tooltip");
export default {
  name: "bar-ratio",
  props: {
    volume_data: [Array, Object],
    width: Number,
    height: Number,
    barWidth: {
      type: Number,
      default: 50,
    },
    barCategoryGap: {
      type: Number,
      default: 30,
    },
    is_loading: Boolean,
  },
  data() {
    return {
      chart_id: this.$uuid.v1(),
      chart: {},
    };
  },
  watch: {
    volume_data(new_val) {
      this.chart.showLoading();
      this.volume_data = new_val;
      this.draw();
    },
    is_loading(new_val) {
      new_val ? this.chart.showLoading() : this.chart.hideLoading();
    },
  },
  mounted() {
    this.chart = echarts.init(document.getElementById(this.chart_id));
    this.chart.showLoading();
  },
  methods: {
    draw() {
      const _this = this;
      const data = _this.volume_data;

      if (null == data || "undefined" == typeof data || "" == data) {
        this.chart.hideLoading();
        this.chart.setOption({xAxis: {type: 'category',data: ['暂无数据']},yAxis: {type: 'value'}}, true);
        return;
      }

      let xAxisData = [];
      let categoryDate = [];
      let typeData = [];
      let legendData = [];
      let seriesData = [];

      xAxisData = Array.from(
        new Set(
          data.map(function (x) {
            return x.date;
          })
        )
      );

      legendData = Array.from(
        new Set(
          data.map(function (x) {
            return (x.category === null ? "" : x.category + "-") + x.project;
          })
        )
      );

      data.forEach((item) => {
        if (typeof(typeData.find(t => t.category === item.category && t.project === item.project)) === 'undefined') 
        {
          typeData.push({
            category: item.category,
            project: item.project,
          });
        }
      });

      categoryDate = Array.from(
        new Set(
          data.map(function (x) {
            return x.category;
          })
        )
      );

      const colors = [
        [
          "#104A7F",
          "#275987",
          "#3870A4",
          "#2F7CC8",
          "#418FDB",
          "#67A0D9",
          "#84B5E7",
          "#C2D9F3",
        ],
        ["#F56300", "#FC802D", "#FF912C", "#FFBE88", "#FFD4B0"],
        ["#8662A6", "#B7A1CA", "#CEC0DC"],
        ["#73B2CC", "#589BB7"],
        ["#789ADC", "#6086D0"],
      ];

      for(let i in categoryDate){
        let group = typeData.filter(t => t.category === categoryDate[i]);
        for (let j in group) {
          var ratio = [];
          data.forEach(function (item) {
            if (item.category === group[j].category && item.project === group[j].project) {
              ratio.push(item.ratio);
            }
          });
          seriesData.push({
            name: (group[j].category === null ? "" : group[j].category + "-") + group[j].project,
            type: "bar",
            stack: "ratio",
            data: ratio,
            barWidth: _this.barWidth,
            barCategoryGap: _this.barCategoryGap,
            // emphasis: {
            //   focus: "series",
            // },
            color: colors[i][j]
          });
        }
      }

      const tooltip_group = {
          trigger: "axis",
          // confine: true,
          axisPointer: {
            type: "shadow", 
          },
          formatter: (params)=>{
            if(categoryDate[0] === null)
              return params;

            let list = [];
            if(params&&params.length > 0)
            {
              list.push('<div class="carinfo">')
              list.push('<div style="font-size:12px;color:#666;font-weight:400;line-height:1;">' + params[0]?.name + '</div>')
            }
            list.push('<div style="margin: 10px 0 0;line-height:1;">');
            
            list.push('<div style="margin: 10px 0 0;line-height:1;">');
            list.push('<span style="width:87px;text-align:left!important;font-weight:800" ></span>');
            list.push('<span style="width:10px;margin-left:20px;font-size:12px;color:#666;font-weight:800;">数量</span>')
            list.push('<span style="width:10px;margin-left:20px;font-size:12px;color:#666;font-weight:800;">同比</span>')
            list.push('<span style="width:10px;margin-left:20px;font-size:12px;color:#666;font-weight:800;">份额</span>')
            list.push('</div>');

            for(let i in categoryDate){

              let this_year_volume = data.filter(t => t.category === categoryDate[i] && t.date === params[0]?.name)
                  .map(t => t.volume)
                  .reduce((prev,next) => prev + next);
              let last_year_volume = data.filter(t => t.category === categoryDate[i] && t.date === params[0]?.name)
                  .map(t => t.lastVolume)
                  .reduce((prev,next) => prev + next);
              list.push('<div style="margin: 5px 0 0;line-height:1;">');
              list.push('<span style="width:87px;text-align:left!important;font-weight:800" >' + categoryDate[i] + '</span>');
              list.push('<span style="width:10px;margin-left:20px;font-size:12px;color:#666;font-weight:800;">' + 
                this_year_volume.toLocaleString()
              + '</span>')
              list.push('<span style="width:10px;margin-left:20px;font-size:12px;color:#666;font-weight:800;">' + 
                (last_year_volume === 0 ? '-' : ((this_year_volume - last_year_volume ) / last_year_volume * 100).toFixed(2) + '%')
              +'</span>')

              list.push('<span style="width:10px;margin-left:20px;font-size:12px;color:#666;font-weight:800;">' +
                data.filter(t => t.category === categoryDate[i] && t.date === params[0]?.name)
                  .map(t => t.ratio)
                  .reduce((prev,next) => prev + next).toLocaleString()
              + '%</span>')
              for(let param of params){
                if(categoryDate[i] === param.seriesName.split('-')[0]){
                  list.push('<div style="margin: 5px 0 0;line-height:1;">');
                  list.push('<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;min-width:10px;background-color:' + param.color + ';"></span>')
                  list.push('<span style="font-size:12px;color:#666;font-weight:400;margin-left:2px">' + param.seriesName.split('-')[1] + '</span>');
                  list.push('<span style="width:10px;margin-left:20px;font-size:12px;color:#666;">' + 
                    data.find(t => t.category === categoryDate[i] && t.project === param.seriesName.split('-')[1] && t.date === params[0]?.name).volume.toLocaleString() + 
                  '</span>')
                  list.push('<span style="width:10px;margin-left:20px;font-size:12px;color:#666;">' + 
                    data.find(t => t.category === categoryDate[i] && t.project === param.seriesName.split('-')[1] && t.date === params[0]?.name).yoy
                  + '%</span>')
                  list.push('<span style="width:10px;margin-left:20px;font-size:12px;color:#666;">' + param.value + '%</span>')
                  
                  list.push('</div>');
                }
              }
              
              list.push('</div>');
            }
            list.push('</div>');
            list.push('</div>');
            list.push('<div style="clear:both"></div>');
            return list.join("");
          },
          position: ['-75%', '-10%']
        };
      var option = {
        legend: {
          type: "scroll",
          data: legendData,
          icon: "circle",
          bottom: 1,
          left: "center",
          padding: [20, 52, 20, 52],
          itemWidth : 20,
          itemHeight : 10,
        },
        tooltip: categoryDate[0] === null ? 
        {
          trigger: "axis",
          confine: true,
          axisPointer: {
            type: "shadow", 
          },
          formatter: (params) => {
            let list = [];
            if(params && params.length > 0)
            {
              list.push('<span style="font-size:12px;color:#6e7079;margin-left:2px">' + params[0]?.name + '</span><div style="clear:both"></div>')
            }
            let listItem = "";
            for (let param of params) {
              list.push(
                param.marker +
                  '<span style="display:inline-block;font-size:12px;color:#6e7079;margin-left:2px;width:70px;">' +
                    param.seriesName
                  +
                  '</span>：' +
                  '<span style="font-size:12px;margin-left:5px;">' +
                    param.value.toLocaleString() +
                  "%</span>" +
                  '<div style="clear:both"></div>'
              );
            }
            listItem = list.join("");
            return listItem;
          },
        } 
        : tooltip_group,
        xAxis: [
          {
            type: "category",
            data: xAxisData,
          },
        ],
        yAxis: [
          {
            type: "value",
            max: 100,
            axisLabel: {
              show: true,
              interval: "auto",
              formatter: "{value} %",
            },
          },
        ],
        series: seriesData,
      };

      // this.chart.clear();
      this.chart.setOption(option, true);
      this.chart.hideLoading();
    },
  },
};
</script>
